<!-- Chrome-theme match offer. Same bulletproof, transform-free, literal-colour
     approach as the cookie toast (see cookie-popup) so the text can never
     composite away on iOS Safari. Shows only when the All In One Themes
     extension reports a selected theme the site is not already wearing. -->
<div *ngIf="offeredTheme | async as theme" class="theme-offer" role="region"
     [class.theme-offer--raised]="cookieVisible"
     aria-label="Browser theme match offer">
  <img class="theme-offer-logo" [src]="theme.logo" [alt]="theme.name + ' logo'" />

  <p class="theme-offer-message">
    You are using the <a class="theme-offer-name" [routerLink]="URLS.theme"
       [queryParams]="{ product: theme.key, category: categoryOf(theme) }">{{ theme.name }}</a> theme in Chrome. Match the site to it?
  </p>

  <div class="theme-offer-actions">
    <button class="theme-offer-dismiss" type="button" (click)="dismiss()">Not now</button>
    <div class="codigrate-button theme-offer-accept" role="button" tabindex="0"
         (click)="accept()" (keyup.enter)="accept()">
      <p>Match</p>
    </div>
  </div>
</div>
